/*
 * サブシステム名：車両別実績帳票出力
 * 機能名：車両別実績帳票出力
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import message from '@/ddv2.library/messages'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import DdAutocompleteChipBox from '@/components/DdAutocompleteChipBox.vue'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDateBox from '@/components/DdDateBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdDropDown from '@/components/DdDropDown'
import DdMonthRangeBox from '@/components/DdMonthRangeBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox.vue'

export default {
  name: 'SharyobetsuJissekiOutput',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdAutocompleteChipBox,
    DdCodeTextBox,
    DdDateBox,
    DdDateRangeBox,
    DdDropDown,
    DdMonthRangeBox,
    DdRadioButton,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    conditions: {},
    chohyoSbt: '0',
    modeKengen: 0,
    // 表示制御
    dispCsvNm: '',
    dispPdfNm: '',
    page: 1,
    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    keijoDayDisp: false,
    unkoDayDisp: false,
    shukkoDayDisp: false,
    dayDisp: false,
    ymdDisp: true,
    ymDisp: false,
    yDisp: false,
    seikyuTomeSbtDisp: false,
    unchinKakuteiSbtDisp: false
  }),
  watch: {
    chohyoSbt: function () {
      if (this.chohyoSbt === '0') {
        this.conditions.daySbt = '01'
        this.keijoDayDisp = true
        this.unkoDayDisp = true
        this.shukkoDayDisp = true
        this.ymdDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.seikyuTomeSbtDisp = true
        this.unchinKakuteiSbtDisp = true
      } else if (this.chohyoSbt === '1') {
        // 運行実績一覧表
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.unkoDayDisp = true
        this.shukkoDayDisp = false
        this.ymdDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '2') {
        // 日計表
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.unkoDayDisp = true
        this.shukkoDayDisp = false
        this.ymdDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '3') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.unkoDayDisp = true
        this.shukkoDayDisp = false
        this.ymdDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '4') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.unkoDayDisp = true
        this.shukkoDayDisp = false
        this.ymdDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '5') {
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.unkoDayDisp = true
        this.shukkoDayDisp = false
        this.ymdDisp = false
        this.ymDisp = false
        this.yDisp = true
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '6') {
        // 収支実績表
        this.conditions.daySbt = '02'
        this.keijoDayDisp = false
        this.unkoDayDisp = true
        this.shukkoDayDisp = false
        this.ymdDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '7') {
        // 車両整備予定表
        this.conditions.daySbt = '01'
        this.keijoDayDisp = true
        this.unkoDayDisp = false
        this.shukkoDayDisp = false
        this.ymdDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      } else if (this.chohyoSbt === '8') {
        // 車両修理経費時系列一覧
        this.conditions.daySbt = '01'
        this.keijoDayDisp = true
        this.unkoDayDisp = false
        this.shukkoDayDisp = false
        this.ymdDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.seikyuTomeSbtDisp = false
        this.unchinKakuteiSbtDisp = false
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredEigyoshoListArray () {
      var defArray = []
      const resultArray = this.filteredEigyoshoList.map(elem => {
        return {
          value: elem.eigyoshoCd,
          text: elem.eigyoshoNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 営業所マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || t.eigyoshoCd === self.userEigyoshoCd)
      })
    },
    filteredMstSharyoListArray () {
      var defArray = []
      const resultArray = this.filteredMstSharyoList.map(elem => {
        return {
          value: elem.sharyoNo,
          text: elem.jidoshaHyojiNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 車両マスタフィルター <-- ここまで
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filteredSharyoShubetsListArray () {
      var defArray = []
      const resultArray = this.sbtListFilter(this.shubetsuList, 'GVI011').map(elem => {
        return {
          value: elem.sbtCd,
          text: elem.sbtNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 車両グループ１フィルター
    filteredSharyoGroup1List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI012')
    },
    filteredSharyoGroup1ListArray () {
      var defArray = []
      const resultArray = this.sbtListFilter(this.shubetsuList, 'GVI012').map(elem => {
        return {
          value: elem.sbtCd,
          text: elem.sbtNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 車両グループ２フィルター
    filteredSharyoGroup2List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI013')
    },
    filteredSharyoGroup2ListArray () {
      var defArray = []
      const resultArray = this.sbtListFilter(this.shubetsuList, 'GVI013').map(elem => {
        return {
          value: elem.sbtCd,
          text: elem.sbtNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 車両グループ３フィルター
    filteredSharyoGroup3List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI016')
    },
    filteredSharyoGroup3ListArray () {
      var defArray = []
      const resultArray = this.sbtListFilter(this.shubetsuList, 'GVI016').map(elem => {
        return {
          value: elem.sbtCd,
          text: elem.sbtNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 車両グループ４フィルター
    filteredSharyoGroup4List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI017')
    },
    filteredSharyoGroup4ListArray () {
      var defArray = []
      const resultArray = this.sbtListFilter(this.shubetsuList, 'GVI017').map(elem => {
        return {
          value: elem.sbtCd,
          text: elem.sbtNm
        }
      })
      return defArray.concat(resultArray)
    },
    // 車両グループ５フィルター
    filteredSharyoGroup5List () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI018')
    },
    filteredSharyoGroup5ListArray () {
      var defArray = []
      const resultArray = this.sbtListFilter(this.shubetsuList, 'GVI018').map(elem => {
        return {
          value: elem.sbtCd,
          text: elem.sbtNm
        }
      })
      return defArray.concat(resultArray)
    },
    // '車両グループ'の記載がなければ設定ありと判断
    isSettingSharyoGroup1 () {
      if (this.filteredSharyoGroup1ListArray.length === 0) return false
      return this.filteredSharyoGroup1ListArray[0].text.indexOf('車両グループ') < 0
    },
    isSettingSharyoGroup2 () {
      if (this.filteredSharyoGroup2ListArray.length === 0) return false
      return this.filteredSharyoGroup2ListArray[0].text.indexOf('車両グループ') < 0
    },
    isSettingSharyoGroup3 () {
      if (this.filteredSharyoGroup3ListArray.length === 0) return false
      return this.filteredSharyoGroup3ListArray[0].text.indexOf('車両グループ') < 0
    },
    isSettingSharyoGroup4 () {
      if (this.filteredSharyoGroup4ListArray.length === 0) return false
      return this.filteredSharyoGroup4ListArray[0].text.indexOf('車両グループ') < 0
    },
    isSettingSharyoGroup5 () {
      if (this.filteredSharyoGroup5ListArray.length === 0) return false
      return this.filteredSharyoGroup5ListArray[0].text.indexOf('車両グループ') < 0
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteLeaveByMenu: function (next) {
    const option = {
      nextCallback: next
    }
    this.preventTransition(option)
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'vwcmstsharyo', 'mstshubetsu'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    settingStartYm: function (p) {
      this.$set(this.conditions, 'startYm', p)
    },
    settingEndYm: function (p) {
      this.$set(this.conditions, 'endYm', p)
    },
    onCsvButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.Effects.loadStart()
      this.clearSummaryMessage()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispCsvNm = `運行明細表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1010/CsvDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispCsvNm = `運行実績一覧表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1020/CsvDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispCsvNm = `日計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1030/CsvDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispCsvNm = `売上集計表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1050/CsvDownload'
      } else if (this.chohyoSbt === '4') {
        this.dispCsvNm = `売上集計表(種別)_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1040/CsvDownload'
      } else if (this.chohyoSbt === '5') {
        this.dispCsvNm = `年間月別売上対比表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1060/CsvDownload'
      } else if (this.chohyoSbt === '6') {
        this.dispCsvNm = `収支実績表_${this.getTimeStamp()}.csv`
        post = '/api/v1/D2bzmp1070/CsvDownload'
      } else if (this.chohyoSbt === '7') {
        this.dispCsvNm = `車検整備予定表_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1080/CsvDownload'
      } else if (this.chohyoSbt === '8') {
        this.dispCsvNm = `車両修理経費時系列一覧_${this.getTimeStamp()}.csv`
        post = '/api/v1/vwCD2bzmp1090/CsvDownload'
      }
      this.HttpClient
        .post(post, this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.clearSummaryMessage()
      console.log(e)
      this.Effects.loadStart()
      let post = ''
      if (this.chohyoSbt === '0') {
        this.dispPdfNm = `運行明細表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1010/PdfDownload'
      } else if (this.chohyoSbt === '1') {
        this.dispPdfNm = `運行実績一覧表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1020/PdfDownload'
      } else if (this.chohyoSbt === '2') {
        this.dispPdfNm = `日計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1030/PdfDownload'
      } else if (this.chohyoSbt === '3') {
        this.dispPdfNm = `売上集計表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1050/PdfDownload'
      } else if (this.chohyoSbt === '4') {
        this.dispPdfNm = `売上集計表(種別)_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1040/PdfDownload'
      } else if (this.chohyoSbt === '5') {
        this.dispPdfNm = `年間月別売上対比表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1060/PdfDownload'
      } else if (this.chohyoSbt === '6') {
        this.dispPdfNm = `収支実績表_${this.getTimeStamp()}.xlsm`
        post = '/api/v1/D2bzmp1070/ExcelOutput'
        this.HttpClient
          .requestFileByPost(post, this.conditions).then(data => {
            // aタグにファイル仕込んでClickする処理
            const blob = new Blob([data], { type: 'application/vnd.ms-excel.sheet.macroEnabled.12' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          })
        return
      } else if (this.chohyoSbt === '7') {
        this.dispPdfNm = `車検整備予定表_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1080/PdfDownload'
      } else if (this.chohyoSbt === '8') {
        this.dispPdfNm = `車両修理経費時系列一覧_${this.getTimeStamp()}.pdf`
        post = '/api/v1/vwCD2bzmp1090/PdfDownload'
      }
      this.HttpClient
        .requestFileByPost(post, this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
        })
    },
    clientValidate: function () {
      var msg
      var startYmd
      var endYmd
      if (this.dayDisp) {
        if (!this.conditions.startDay) {
          this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startDay && this.conditions.endDay) {
          msg = validators.compareDate(this.conditions.startDay, this.conditions.endDay)
          if (msg !== undefined) {
            this.$refs.startDay[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endDay[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      if (this.ymDisp) {
        if (!this.conditions.startYm) {
          this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startYm && this.conditions.endYm) {
          startYmd = Date.parse(this.conditions.startYm + '/01')
          endYmd = Date.parse(this.conditions.endYm + '/01')
          msg = validators.compareDate(startYmd, endYmd)
          if (msg !== undefined) {
            this.$refs.startYm[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endYm[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      if (this.yDisp) {
        if (!this.conditions.startY) {
          this.$refs.startY[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
          return false
        }
        if (this.conditions.startY && this.conditions.endY) {
          startYmd = Date.parse(this.conditions.startY + '/01/01')
          endYmd = Date.parse(this.conditions.endY + '/01/01')
          msg = validators.compareDate(startYmd, endYmd)
          if (msg !== undefined) {
            this.$refs.startY[this.Ctrls.SET_INVALID_METHOD](msg)
            this.$refs.endY[this.Ctrls.SET_INVALID_METHOD](msg)
            return false
          }
        }
      }
      return true
    },
    onClearButtonClick: function () {
      this.initBindVariables()
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      var today = new Date()
      // 前月とする為、getMonthの+1は不要
      var togetsu = ('000' + today.getFullYear()).slice(-4) + '/' + ('0' + (today.getMonth())).slice(-2)
      var year = ('000' + today.getFullYear()).slice(-4)
      const startDay = date.getFirstDate(today.getFullYear(), today.getMonth())
      const endDay = date.getLastDate(today.getFullYear(), today.getMonth())
      this.conditions = {
        daySbt: '01',
        seikyuTomeSbt: '99',
        unchinKakuteiSbt: '99',
        startDay: startDay,
        endDay: endDay,
        startYm: togetsu,
        endYm: togetsu,
        startY: year,
        endY: year,
        startShashuSbt: null,
        endShashuSbt: null,
        startSharyoGroup1Sbt: null,
        endSharyoGroup1Sbt: null,
        startSharyoGroup2Sbt: null,
        endSharyoGroup2Sbt: null,
        startSharyoGroup3Sbt: null,
        endSharyoGroup3Sbt: null,
        startSharyoGroup4Sbt: null,
        endSharyoGroup4Sbt: null,
        startSharyoGroup5Sbt: null,
        endSharyoGroup5Sbt: null,
        startEigyoshoCd: null,
        endEigyoshoCd: null,
        startSharyoCd: null,
        endSharyoCd: null,
        eigyoshoCdList: [],
        sharyoNoList: [],
        shashuSbtList: [],
        sharyoGroup1SbtList: [],
        sharyoGroup2SbtList: [],
        sharyoGroup3SbtList: [],
        sharyoGroup4SbtList: [],
        sharyoGroup5SbtList: []
      }
      this.conditions.eigyoshoCdList[0] = this.userEigyoshoCd
      // 表示制御
      this.chohyoSbt = '0'
      this.keijoDayDisp = true
      this.unkoDayDisp = true
      this.shukkoDayDisp = true
      this.ymDisp = false
      this.yDisp = false
      this.seikyuTomeSbtDisp = true
      this.unchinKakuteiSbtDisp = true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
